import * as React from 'react'
import type { SVGProps } from 'react'
const SvgCaretDown = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" {...props}>
		<path fill="currentColor" d="m11.998 17 7-8h-14z" />
	</svg>
)
export default SvgCaretDown
